import { Reveal } from "@/components/Reveal";

const testimonials = [
  {
    quote: "I joined Training Basket confused about my career. Six months later I had a job offer in cloud computing. Nayan sir doesn't oversell — he quietly makes sure you're actually ready.",
    name: "Rohit Sharma",
    role: "Training Basket Alumnus / Cloud Engineer",
  },
  {
    quote: "CoWorkZen doesn't feel like renting a desk. It feels like someone thought deeply about how founders actually work. That someone is Nayan.",
    name: "Priya Malhotra",
    role: "Startup Founder / CoWorkZen Member",
  },
  {
    quote: "Most partners talk big and deliver small. Nayan does the opposite. Our outlet launch was the smoothest franchise experience we've had.",
    name: "Arjun Kapoor",
    role: "F&B Partner / The Burger Company",
  },
  {
    quote: "He listens more than anyone I've done business with. Then, weeks later, everything you said shows up in the execution — better than you imagined it.",
    name: "Vishal Datt Wadhwa",
    role: "Co-Founder / CoWorkZen",
  },
];

export const Testimonials = () => (
  <section id="testimonials" className="bg-[#EFEAE1] py-28 lg:py-36" data-testid="testimonials-section">
    <div className="px-5 lg:px-10">
      <Reveal>
        <h2 className="font-giant text-[12vw] lg:text-[7.5vw] leading-[0.9] text-[#121110]">
          TESTIM<span className="font-swash text-[#A8512E] text-[10vw] lg:text-[6vw]">o</span>NIALS
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-20 mt-20 max-w-6xl">
        {testimonials.map((t, i) => (
          <Reveal key={t.name} delay={(i % 2) * 0.12}>
            <figure data-testid={`testimonial-card-${i}`}>
              <blockquote className="text-lg lg:text-xl leading-relaxed text-[#121110]">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4">
                <span className="w-12 h-12 rounded-full bg-[#121110] text-[#EFEAE1] font-giant text-xl flex items-center justify-center">
                  {t.name[0]}
                </span>
                <span className="text-sm text-[#4A453F]">
                  <strong className="text-[#121110]">{t.name}</strong> / {t.role}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
